import { Icon } from '@iconify/react'
import { Tooltip } from '@pepper/ui'

import { ReportType, ResearchReportDocument } from '@pepper/utils/src/types/seo'
import { getGapMetrics, getMetrics } from './ContentGuidelines.utils'

import styles from './ContentGuidelines.module.css'

function contentMetric(
  reportType: ReportType | undefined,
  report: ResearchReportDocument
) {
  return reportType === 'GAP'
    ? getGapMetrics(report).map(metric => {
        return (
          <div key={metric.title} className={styles.metricItem}>
            <div className={styles.metricItemWrapper}>
              <div>{metric.title}</div>
              <div className={styles.metricValueWrapper}>
                <div>
                  <p
                    style={{ color: metric.color.color }}
                    className={styles.metricCurrentValue}
                    dangerouslySetInnerHTML={{
                      __html: metric.current_value,
                    }}
                  />
                  <p className={styles.metricValueText}>Current</p>
                </div>
                <div>
                  <p
                    className={styles.metricIdealValue}
                    dangerouslySetInnerHTML={{
                      __html: metric.ideal_value,
                    }}
                  />
                  <p className={styles.metricValueText}>Ideal</p>
                </div>
              </div>
            </div>
            {metric.info && (
              <Tooltip
                title={metric.info}
                placement="left"
                className={styles.metricInfoTooltip}
              >
                <Icon icon="lucide:info" />
              </Tooltip>
            )}
          </div>
        )
      })
    : getMetrics(report).map(metric => (
        <div key={metric.title} className={styles.metricItem}>
          <h4 className={styles.metricItemTitle}>
            <span>{metric.title}</span>
            <span dangerouslySetInnerHTML={{ __html: metric.value }} />
          </h4>
          {metric.info && (
            <Tooltip
              title={metric.info}
              placement="left"
              className={styles.metricInfoTooltip}
            >
              <Icon icon="lucide:info" />
            </Tooltip>
          )}
        </div>
      ))
}

export default contentMetric
